import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="anchor"
export default class extends Controller {
  static targets = ["demo"]

  scroll() {
    console.log( this.hasDemoTarget )
    if (!this.hasDemoTarget) return

    this.demoTarget.scrollIntoView({
      behavior: "smooth",
      block: "start"
    })
  }
}